import useCart from '../hooks/useCart';
import { cartCount, openCart } from '../lib/cart';

// Cart link with a live count. Drop into Header.jsx next to the Call Us button.
// Renders nothing when the cart is empty, so it never clutters the header for
// the majority of visitors who are just reading.

export default function CartButton({ className = '' }) {
  const lines = useCart();
  const count = cartCount(lines);
  if (!count) return null;

  return (
    <button
      type="button"
      onClick={openCart}
      aria-label={`Cart, ${count} item${count === 1 ? '' : 's'}`}
      className={`relative inline-flex items-center gap-2 rounded-md border-2 border-blue-600 px-3 py-2 text-sm font-medium text-blue-600 transition hover:bg-blue-50 ${className}`}
    >
      <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 3h2l2.6 12.4a1 1 0 001 .8h9.7a1 1 0 001-.8L21 7H6" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="9" cy="20" r="1.4" /><circle cx="18" cy="20" r="1.4" />
      </svg>
      <span className="hidden sm:inline">Cart</span>
      <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-blue-600 px-1.5 text-[11px] font-semibold text-white">
        {count}
      </span>
    </button>
  );
}